export enum FoundingDocument {
  NotSelected = 0,
  PowerOfAttorney = 4,
  Charter = 6,
}
